import fetchWithCSRF from './fetch-with-csrf';

/**
 * @deprecated With the current implementation you can't access the HTTP status
 * code and therefore can't react to errors like 5xx etc. Please use
 * fetch-with-csrf.js with the additional line .then(response => response.json())
 * instead. This way you can directly access response.status.
 */
export default function (url, options) {
    return fetchWithCSRF(url, options)
        .then((response) => {
            return response.json();
        });
}
